<div class="registration-container" *ngIf="showContent">  <!-- Toast Message Component -->  
  <div  *ngIf="showToast" class="toast-container">
    <div [ngClass]="['toast-message', toastType === 'success' ? 'toast-success' : 'toast-error']">
      <div class="toast-content">
        <div class="toast-text">
          <div class="toast-title">{{ toastTitle }}</div>
          <div class="toast-message-text">{{ toastMessage }}</div>
        </div>
       <span class="material-symbols-outlined p-0 cursor-pointer" 
        id="btn_phone_update_close_toast"
        (click)="closeToast()"
        (keypress)="closeToast()"
        *ngIf="toastType === 'success' || toastType === 'error'" 
        title="Close">close</span>
      </div>
    </div>
  </div>

  <!-- Combined Header and Content Card -->
  <div class="main-content">
    <div class="content-card">      <!-- Header Section -->
       <div class="row justify-content-center mt-2 mb-4">
            <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
                <img src="assets/images/edu-logo.svg" alt="{{genericMessage['G0001']}}" class="img-fluid" />
            </div>
        </div>

      <!-- Main Title Section -->
      <h1 class="page-title">Complete Your Registration</h1>
      <p class="page-subtitle">Set your password and verify your contact information to activate your account.</p>      <!-- Account Information Section -->
      <hr class="section-divider">      <div class="section">
        <h2 class="section-title">Email Verification</h2>
        <p class="section-subtitle">Your email address has been verified.</p>
          <div class="form-group">
          <label class="form-label" for="email-input">Email</label>
          <input
            id="email-input"
            type="email"
            class="form-input"
            [(ngModel)]="email"
            readonly
          />
        </div>
      </div>

      <!-- Phone Verification Section -->
      <hr class="section-divider">
      <div class="section">
        <h2 class="section-title">Phone Verification</h2>
        <p class="section-subtitle">Enter the 6-digit code sent via SMS to verify your phone number.</p>          
        <div class="form-group">
          <label class="form-label" for="phone-input">Phone Number</label>
          <input
            id="phone-input"
            type="tel"
            class="form-input"
            [(ngModel)]="phoneNumber"
            readonly
          />
        </div>
               <div class="form-group">
          <label class="form-label" for="otp-container" id="otp-label">Verification Code <span class="requiredfield text-danger">*</span></label>
          <div id="otp-container" class="otp-container" aria-labelledby="otp-label">
            <input
              *ngFor="let digit of getInputIds(); let i = index"
              [id]="'otp-input-' + i"
              type="text"
              class="otp-input"
              [class.error]="(attempts > 0 && !isPhoneVerified) || (inputBlurred[i] && otpDigits[i] === '')"
              maxlength="1"
              (input)="onInputChange($event, i)"
              (keydown)="onKeyDown($event, i)"
              (paste)="onPaste($event)"
              (focus)="onInputFocus(i)"
              (blur)="onInputBlur(i)"
              [disabled]="isRecoveryOtpDisabled(i)"
              autocomplete="off"
              [attr.aria-label]="'Digit ' + (i + 1) + ' of Verification Code'"
            />
          </div>
          <div *ngIf="showOtpEmptyError" class="error-message-otp">
            Please enter the verification code sent to your phone.
          </div>
        </div>
        <div class="resend-section justify-content-center">
          <button
            type="button"
            class="resend-button"
            (click)="onResendCode()"
            [disabled]="isResendDisabled()"
          >
            Resend Code
          </button>
          <!-- 30s timer for resend, only when not blocked -->
          <span class="timer" *ngIf="timeRemaining > 0 && resendCount > 0 && !isBlocked">{{ formattedTime }}</span>
          <!-- 15min timer after 5th failed attempt, only when blocked -->
          <span class="timer" *ngIf="timeRemaining > 0 && isBlocked">{{ formattedTime }}</span>
        </div>
        <button
          type="button"
          class="verify-button"
          (click)="onVerifyPhoneNumber()"
          [disabled]="isBlocked || isPhoneVerified || otpDigits.length < 6 || otpDigits.includes('') || timeRemaining > 0 || resendCount >= maxResendCount"
        >
          Verify Phone Number
        </button>
        
        <!-- Update Phone Number Link -->
        <div class="update-phone-container">
          <a href="#" class="update-phone-link" (click)="navigateToPhoneUpdate(); $event.preventDefault()">Update Phone Number</a>
        </div>
      </div>
    </div>
  </div>
</div>
